import React from "react";

const palette = {
  notDue: {
    title: "Not Due",
    classes: "bg-emerald-50 text-emerald-700 border border-emerald-100",
  },
  due: {
    title: "Due",
    classes: "bg-amber-50 text-amber-700 border border-amber-100",
  },
  notCompliant: {
    title: "Not Compliant",
    classes: "bg-red-50 text-red-700 border border-red-100",
  },
  compliant: {
    title: "Compliant",
    classes: "bg-emerald-100 text-emerald-800 border border-emerald-200",
  },
};

const ComplianceSummaryCard = ({ statusKey, count }) => {
  const config = palette[statusKey] || palette.due;
  return (
    <div className={`rounded-xl p-4 shadow-sm ${config.classes}`}>
      <p className="text-xs uppercase tracking-wide">{config.title}</p>
      <p className="mt-2 text-2xl font-semibold">{Number(count || 0)}</p>
    </div>
  );
};

export default ComplianceSummaryCard;
